import { SpecIDFallback } from '@interfaces/models/spec-id-fallback.enum';
import { createAction, props } from '@ngrx/store';
import { GiftRecipientTypes, MultiSignerSignState, YesNoEmpty } from '@shared/models';
import { GiftingRecipient } from '@store/reducers/gifting/gifting.reducer';

export const ResetRecipientState = createAction('[Selected Client Accounts] Reset Recipient State');

export const ClearGiftingState = createAction('[Gifting State] Clear existing gifting state');

export const UpdateRecipientAnonymousGift = createAction(
  '[Selected Client Accounts] Update Anonymous Gift',
  props<{ payload: YesNoEmpty }>(),
);

export const UpdateRecipientDTCNumber = createAction(
  '[Selected Client Accounts] Update DTC Number',
  props<{ payload: string }>(),
);

export const UpdateRecipientType = createAction(
  '[Selected Client Accounts] Update Recipient Type',
  props<{ payload: GiftRecipientTypes }>(),
);

export const UpdateRecipientFirm = createAction(
  '[Selected Client Accounts] Update Recipient Firm',
  props<{ payload: string }>(),
);

export const UpdateRecipientName = createAction(
  '[Selected Client Accounts] Update Recipient Name',
  props<{ payload: string }>(),
);

export const UpdateRecipientAccountNumber = createAction(
  '[Selected Client Accounts] Update Recipient Account Number',
  props<{ payload: string }>(),
);

export const UpdateTotalGiftAmount = createAction(
  '[Cost Basis] Update Total Gift Amount',
  props<{ payload: string }>(),
);

export const UpdateRecipientProperties = createAction(
  '[Selected Client Accounts] Update Recipient Properties',
  props<{ payload: Partial<GiftingRecipient> }>(),
);

export const JointGiftingApproval = createAction('[Request] Joint Gifting Approval');

export const JointGiftingApprovalFailed = createAction('[Request] Joint Gifting Approval Failed');

export const JointGiftingApprovalCompleted = createAction(
  '[Request] Joint Gifting Approval Completed',
);

export const JointGiftingApprovalInProgress = createAction(
  '[Request] Joint Gifting Approval InProgress',
);

export const ClearJointGiftingApprovalState = createAction(
  '[Gifting Confirm] Clear Joint Gifting Approval State',
);

export const UpdateGiftId = createAction(
  '[Gifting Review] Update Gift Id for Additional Signer',
  props<{ payload: string }>(),
);

export const UpdateSignState = createAction(
  '[Gifting Review] Update Sign state for Additional Signer',
  props<{ payload: MultiSignerSignState }>(),
);

export const UpdateSpecIDFallback = createAction(
  '[Gifting Review] Update Spec ID Fallback',
  props<{ payload: SpecIDFallback }>(),
);
